import { createFileRoute } from "@tanstack/react-router";
import {
  cmsHomeRouteConfig,
  withSiteGlobals,
} from "@decocms/tanstack";
import { DecoPageRenderer } from "@decocms/tanstack";
import { deferredSectionLoader } from "@decocms/tanstack/sdk/deferredSectionLoader";
import { headFromSeoSections } from "~/components/seo/seoHead";
import { SITE } from "~/constants";

const HOME_CANONICAL = `${SITE.URL}/`;

// `withSiteGlobals` wraps the loader so that sections declared in
// `.deco/blocks/Site.json` under `global` (Minicart drawer, Fonts,
// LowStockModal, etc.) are merged into `data.resolvedSections` on every
// page. Without it, `displayCart.value = true` from AddToCartButton had
// no subscriber and the post-add notification drawer never appeared.
const baseConfig = withSiteGlobals(cmsHomeRouteConfig({
  defaultTitle: SITE.DEFAULT_TITLE,
  defaultDescription:
    "Comprar Produtos Eróticos com Preço de Atacado é na Miess, o maior Sex Shop do Brasil com pgto 10X sem Juros e Frete Grátis SP acima de R$ 250 em compras",
  siteName: SITE.NAME,
}));

export const Route = createFileRoute("/")({
  ...baseConfig,
  // `buildHead` em @decocms/tanstack só emite <link rel="canonical"> quando
  // loaderData.seo.canonical existe no CMS. O home block atual não carrega
  // esse campo, então o canonical sumia do head — parity flagou como
  // regressão de SEO vs prod. Injetar aqui mantém estável independente
  // de edição no admin. Mesmo motivo para <meta property="og:url">.
  head: (input: Parameters<NonNullable<typeof baseConfig.head>>[0]) => {
    const base = baseConfig.head!(input);
    // The home page carries a PageSEO section — when its loader output is
    // present, it is the single source of truth for <head> (see seoHead.ts).
    const fromSection = headFromSeoSections(
      input.loaderData as Parameters<typeof headFromSeoSections>[0],
      base,
    );
    if (fromSection !== base) return fromSection;
    return {
      ...base,
      meta: [
        ...(base.meta ?? []),
        { property: "og:url", content: HOME_CANONICAL },
      ],
      links: [
        ...(base.links ?? []),
        { rel: "canonical", href: HOME_CANONICAL },
      ],
    };
  },
  component: HomePage,
});

function HomePage() {
  const data = Route.useLoaderData() as Record<string, any> | null;

  if (!data) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">Brasilia</h1>
          <p className="text-sm text-base-content/40 mt-2">No CMS page found for /</p>
        </div>
      </div>
    );
  }

  return (
    <DecoPageRenderer
      sections={data.resolvedSections ?? []}
      deferredSections={data.deferredSections ?? []}
      deferredPromises={data.deferredPromises}
      pagePath={data.pagePath}
      pageUrl={data.pageUrl}
      loadDeferredSectionFn={deferredSectionLoader}
    />
  );
}
